<template>
  <div class="shopping-cart">
    <div class="shopping-cart-con w-1200" v-loading="loading">
      <ul class="shopping-cart-header" v-if="!loading && !isNoData && isSign">
        <li class="checkbox"><el-checkbox v-model="isChecked" @change="checkAll" :disabled="isNoData">Product</el-checkbox></li>
        <li class="header-price">Price</li>
        <li class="header-quantity">Quantity</li>
        <li class="header-total">Total</li>
        <li class="header-operation">Operation</li>
      </ul>
      <div class="shopping-cart-list" v-if="!loading && !isNoData && isSign">
        <div class="shop-list" v-for="(shop, shopIndex) in shoppingList" :key="shopIndex">
          <div class="shop-list-togglecheck">
            <!-- <el-checkbox v-model="shop.checked" @change="checkShopAll(shop.shopId)"></el-checkbox> -->
            Store:{{shop.shopName}}
          </div>
          <div class="products-list" v-for="(products,productsIndex) in shop.items" :key="productsIndex">
            <div class="product-item"
              :class="{'error-product-item': (product.productSpec && product.quantity>product.productSpec.invenory) || product.quantity<product.startNum, 'delete-product-item': products.deleteTag}"
              v-for="(product, productIndex) in products.productItems"
              :key="productIndex"
            >
              <div class="product-item-togglecheck">
                <el-checkbox
                  class="check"
                  v-model="product.checked"
                  @change="checkMes(shop,product)"
                  :disabled="(product.productSpec && product.quantity > product.productSpec.invenory)
                    || product.quantity<product.startNum || products.deleteTag===1 || product.showType === 4 || product.showType === 3 || product.showType === 5
                  "></el-checkbox>
              </div>
              <div class="product-item-info">
                <img :src="product.picUrl.includes('http') ? product.picUrl: 'https://img.onloon.co/' + product.picUrl" alt="" class="product-item-pic">
                <div class="item-product-info">
                  <p class="item-name" :title="product.productName" @click="toDetail(products)">{{product.productName}}</p>
                  <p class="item-price-type">{{product.specName}}</p>
                </div>
                <div class="item-unit-price">
                  {{currency}} {{product.displayprice | fixed-num}}
                </div>
                <div class="item-number">
                  <el-input-number size="small" v-model="product.quantity" :min="1" @change="changeQuantity(shop,products,product)"></el-input-number>
                  <p class="error-tips" v-if="product.productSpec&&product.quantity>product.productSpec.invenory">Number does not meet the business sholesale rules</p>
                  <p class="error-tips" v-if="product.quantity<product.startNum">Remaining stock：{{product.startNum}}</p>
                  <p class="delete-tips" v-if="products.deleteTag">The goods are off the shelf</p>
                </div>
                <div class="item-total-price">
                  {{currency}} {{product.displayprice * product.quantity | fixed-num}}
                </div>
                <div class="item-btn-group">
                  <a class="item-btn remore-btn" @click="removeProduct(product)">Remove</a>
                </div>
              </div>
              <div class="shipping-1">
                <div class="shipping-1-loc">
                  Shipping: {{product.freightAmount && product.showType === 2 ? `${currency} ${product.freightAmount}` : ''}}
                  <span v-show="product.showType === 0">
                    <span style="color: #F5AC40">Free shipping</span>
                  </span >
                  <span v-show="product.showType === 1" @click="selectAddress(product, products, shop)">
                    {{currency}} {{product.freightAmount}}
                  </span>
                  <span style="cursor: pointer" v-show="product.showType === 2" @click="selectAddress(product, products, shop)">
                    {{product.receiveCountry}}, {{product.freightTemplateName}}
                  </span>
                  <span style="color: #E05248;cursor: pointer" v-show="product.showType === 3" @click="selectAddress(product, products, shop)">
                    Not in the scope of delivery
                  </span>
                  <span v-show="product.showType === 5 || product.calculateResult === 5">
                    <span style="color: #E05248;">It exceeds the maximum weight that the merchant can support for delivery</span>
                  </span >
                  <i style="margin-left: 4px" v-show="product.showType === 3 || product.showType === 2" class="el-icon-arrow-down"></i>
                </div>
                <div v-show="product.arrInMaxDays && product.arrInMinDays" class="shipping-time">Shipping time {{product.arrInMinDays}}-{{product.arrInMaxDays}} days</div>
              </div>
              <span v-show="product.showType === 4 || product.calculateResult === 4">
                <span style="color: #E05248; line-height: 30px;  font-size: 14px; margin-left: 112px">This product specification does not exist</span>
              </span >
              <!-- <span v-show="product.showType === 5 || product.calculateResult === 5">
                <span style="color: #E05248; line-height: 30px; font-size: 14px; margin-left: 112px">It exceeds the maximum weight that the merchant can support for delivery</span>
              </span > -->
              <el-popover
                placement="bottom-start"
                width="300"
                trigger="click"
                popper-class="additionalInfo-popover"
                v-if="product.customFieldCount > 0"
              >
                <div class="additionalInfo-con">
                  <div class="title">附加信息</div>
                  <div class="additionalInfo-list">
                    <div 
                      v-for="(fieldList, fieldListIndex) in product.customField"
                      :key="fieldListIndex"
                      class="additionalInfo"
                    >
                      <div 
                        v-for="(field, fieldIndex) in fieldList.val"
                        :key="fieldIndex"
                        class="field-item"
                      >
                        <div class="info-base">
                          <img
                            :src="getImagePath(field)"
                            alt=""
                            class="img"
                          />
                          <div class="name">{{ field.name || field.url }}</div>
                        </div>
                        <a :href="field.url" target="_blank"><i class="iconfont-new icondownload"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="additionalInfo-reference" slot="reference">Additional Information（{{ product.customFieldCount }}）</div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="shopping-cart-footer" v-show="!loading && !isNoData && isSign">
        <div class="checkbox"><el-checkbox v-model="isChecked" @change="checkAll" :disabled="isNoData">Select All</el-checkbox></div>
        <div class="footer-right">
          <div class="items-info">
            <p class="words-top">
              <span class="items-number">{{checkedNum}} Item(s) Total: </span>
              <span class="items-price">{{currency}} {{totalPrice}}</span>
            </p>
            <p class="words-bottom">Not include shipping cost</p>
          </div>
          <div style="height: 40px; margin-right: 8px; position: relative" >
            <div class="mask" v-if="checkedNum===0"></div>
            <div class="pay_btn" ref="paypal-btn">
              <div id="paypal-button-container" ></div>
            </div>
          </div>
          <el-button type="primary" :disabled="checkedNum===0" @click="checkOut">Check Out</el-button>
        </div>
      </div>
      <div class="empty-data" v-if="!loading && isNoData || !isSign">
        <img src="../../assets/img/empty-data.png" alt="" class="empty-data-img">
        <p class="empty-tips">Your shopping cart is empty</p>
        <p class="sign-in-tips" v-if="!isSign">
          If you already have an account,
          <a class="sign-in-btn">sign in</a>
          to see your cart.
        </p>
        <p class="contimue-btn" v-if="isSign" @click="goHome">Continue Shopping</p>
      </div>
    </div>
    <select-address
      :visible.sync="visible"
      :curItem="curItem"
      :selectItem="selectItem"
      :productId="productId"
      :shopInfo="shopInfo"
      @updateShipingList="updateShipingList"
    ></select-address>
  </div>
</template>

<script>
import indexApi from '@/api/index/indexApi.js'
import Util from '@/utils/Util.js'
import { mapGetters } from 'vuex'
import { paypal2 } from "@/assets/js/paypal.js"
import SelectAddress from '../cnpts/select-address.vue'
import * as _ from 'lodash'
import JSONP from '@/utils/jsonp'
import Utils from '@/utils/Util'

  export default {
    name: 'shoppingCart',
    components: { SelectAddress },
    data () {
      return {
        shoppingList: [],
        productNumber: 0,
        isChecked: false,
        checkedNum: 0,
        totalPrice: 0,
        loading: false,
        isNoData: true,
        isSign: true,
        productId: '',
        visible: false,
        selectItem: {},
        curItem: {},
        shopInfo: {},
        disableCountry: ''
      }
    },
    mounted () {
      this.getBuyerCartList('reload')
    },
    watch: {},
    computed: {
      ...mapGetters(['currency'])
    },
    methods: {
      getPaypalAddress () {
        this.isLoading = true
        JSONP(`https://www.paypal.com/sdk/js`, {
          'client-id': process.env.PAYPAL_CLIENT_ID,
          'currency': Utils.getCookie('currency') || 'USD',
          'commit': false
        }).then(() => {
          let items = []
          let orderList = this.shoppingList
          orderList.forEach(shop => {
            let productsList = shop.items
            let itemsSub = {
              products: []
            }
            productsList.forEach(products => {
              if (products) {
                let productItems = products.productItems
                productItems.forEach(product => {
                  itemsSub.products.push({
                    productId: product.productSpec ? product.productSpec.productId : '',
                    productSpecId: product.productSpec ? product.productSpec.id : '',
                    quantity: product.quantity + '',
                    freightTemplateId: product.freightTemplateId,
                    customField: JSON.stringify(product.customField || []),
                  })
                })
              }
            })
            items.push(itemsSub)
          })
          paypal2(JSON.stringify((items[0] || {}).products), this.getPaypalDress, this)
          const contentWindow = document.querySelector('iframe')
          contentWindow.onload = () => {
            this.isLoading = false
          }
        })
      },
      getPaypalDress (address, payId) {
        this.payId = payId
        this.checkOut()
      },
      checkMes (shop,item) {
        if (item.checked) {
          this.checkedNum ++
        } else {
          this.checkedNum --
        }
        let productsList = shop.items
        let shopProductNumber = 0
        let shopProductCheckedNumber = 0
        productsList.forEach(products => {
          let productItems = products.productItems
          productItems.forEach(product => {
            shopProductNumber ++
            if (product.checked === true) {
              shopProductCheckedNumber ++
            }
          })
        })
        if (shopProductCheckedNumber !== 0 && (shopProductNumber === shopProductCheckedNumber)) {
          shop.checked = true
        } else {
          shop.checked = false
        }
        if (this.checkedNum === this.productNumber) {
          this.isChecked = true
        } else {
          this.isChecked = false
        }
        this.getTotalPrice()
      },
      checkAll () {
        if (this.isChecked) {
          this.checkedNum = this.productNumber
        } else {
          this.checkedNum = 0
          this.totalPrice = 0
        }
        this.shoppingList.forEach(shop => {
          shop.checked = this.isChecked
          let productsList = shop.items
          productsList.forEach(products => {
            let productItems = products.productItems
            productItems.forEach(product => {
              if (![3, 4, 5].includes(product.showType)) {
                product.checked = this.isChecked
              }
            })
          })
        })
        this.getTotalPrice()
      },
      checkShopAll (shopId) {
        this.shoppingList.forEach(shop => {
          if (shop.shopId === shopId) {
            let productsList = shop.items
            productsList.forEach(products => {
              let productItems = products.productItems
              productItems.forEach(product => {
                if (shop.checked) {
                  if (![3, 4, 5].includes(product.showType)) {
                    product.checked = this.isChecked
                    this.checkedNum ++
                  }
                  // if (!product.checked) {
                  //   product.checked = shop.checked
                  // }
                } else {
                  if (product.checked) {
                    product.checked = shop.checked
                    this.checkedNum --
                  }
                }
              })
            })
          }
        })
        if (this.checkedNum === this.productNumber) {
          this.isChecked = true
        } else {
          this.isChecked = false
        }
        this.getTotalPrice()
      },
      updateShipingList (shop, products, product) {
        console.log('product ===999', product);
        this.changeQuantity(shop, products, product)
      },
      changeCountry () {
        this.shoppingList.length && this.shoppingList[0].items.forEach(v => {
          const logisticsInfo = v.logisticsInfo.logisticsFreightVOS
          v.productItems.forEach(v1 => {
            if (v.showType > 1) {
              let bool = logisticsInfo.some(v2 => {
                console.log(v1.receiveCountry, v2.country);
                let bool = v2.country.includes(v1.receiveCountry)
                if (bool) {
                  v2.logistFreightDetails.forEach(v3 => {
                    if (v3.receiveCountrys.includes(v1.receiveCountry)) {
                      v1.showType = v2.freightBear === 1 ? 0 : 2
                    }
                  })
                }
                return bool
              })

              if (!bool) {
                v1.showType = 3
              }
            }
          })
        })

        console.log(this.shoppingList);
      },
      changeQuantity (shop, products, product) {
        if (product.productSpec && product.quantity > product.productSpec.invenory) {
          this.getTotalPrice()
          return
        }
        this.shopInfo = shop
        let params = {
          id: product.id,
          shopId: shop.shopId,
          productId: products.productId,
          buyerId: localStorage.getItem('BUYERID'),
          freightTemplateId: product.freightTemplateId,
          receiveCountry: product.receiveCountry,
          specName: product.specName,
          quantity: product.quantity
        }
        indexApi.getCartUpdatequantity(params).then(async res => {
          if (!res.data.code) {
            const res2 = await indexApi.getCalculatePrice({
              form: JSON.stringify({
                countryNameEn: product.receiveCountry,
                orderItemList: [{
                  productId: products.productId,
                  productSpecId: product.productSpec.id,
                  quantity: product.quantity,
                  freightTemplateId: product.freightTemplateId,
                  customField: JSON.stringify(product.customField || []),
                }]
              })
            })
            if (res2.data.data.calculateResult) {
              product.calculateResult = res2.data.data.calculateResult
            } else {
              product.calculateResult = 0
            }
            product.freightAmount = res2.data.data.freightAmount
            product.displayprice = 'Expired'
            product.startNum = 0
            let productSpecNums = product.productSpec && product.productSpec.productSpecNums ? product.productSpec.productSpecNums : []
            if(productSpecNums.length){
              product.startNum = productSpecNums[0].startNum
              for(var i = 0, len = productSpecNums.length; i < len; i ++){
                var num = productSpecNums[i].startNum
                product.startNum = num < product.startNum ? num : product.startNum
                if(i < len -1){
                  var num2 = productSpecNums[i+1].startNum
                  if(product.quantity >= num && product.quantity < num2){
                    product.displayprice = productSpecNums[i].price
                  }
                } else{
                  if(product.quantity >= num){
                    product.displayprice = productSpecNums[i].price
                  }
                }
              }
            } else {
              if (product.productSpec && product.productSpec !== null) {
                product.displayprice = product.productSpec.specPrice
              }
            }
          }
          this.getTotalPrice()
        })
      },
      async getTotalPrice () {
        if (!this.checkedNum) {
          this.checkedNum = 0
          this.totalPrice = 0
          return
        }
        let shoppingList = this.shoppingList
        let orderItemList = []
        shoppingList.forEach(shop => {
          let productsList = shop.items
          productsList.forEach(products => {
            let productItems = products.productItems
            productItems.forEach(product => {
              if (product.checked) {
                orderItemList.push({
                  productId: products.productId,
                  productSpecId: product.productSpec.id,
                  quantity: product.quantity,
                  freightTemplateId: product.freightTemplateId,
                  customField: JSON.stringify(product.customField || []),
                })
              }
            })
          })
        })
        const res2 = await indexApi.getCalculatePrice({
          form: JSON.stringify({ orderItemList })
        })
        if (!res2.data.code) {
          this.totalPrice = res2.data.data.goodsAmount
        }
        this.changeCountry()
      },
      getBuyerCartList (type) {
        this.loading = true
        let shopId = Util.getCookie('shopId')
        indexApi.getBuyerCartList({shopId: shopId}).then(res => {
          if (!res.data.code) {
            if (res.data.data && res.data.data.records) {
              let shoppingList = res.data.data.records
              let productNumber = 0
              shoppingList.forEach(shop => {
                if (!shop.checked) {
                  shop.checked = false
                }
                let productsList = shop.items
                productsList.forEach(products => {
                  let productItems = products.productItems
                  productItems.forEach(product => {
                    product.displayprice = 'Expired'
                    product.startNum = 0
                    product.productDetail =  _.cloneDeep(product)
                    product.calculateResult === 0
                    let productSpecNums = product.productSpec && product.productSpec.productSpecNums ? product.productSpec.productSpecNums : []
                    if(productSpecNums.length){
                      product.startNum = productSpecNums[0].startNum
                      for(var i = 0, len = productSpecNums.length; i < len; i ++){
                        var num = productSpecNums[i].startNum
                        product.startNum = num < product.startNum ? num : product.startNum
                        if(i < len -1){
                          var num2 = productSpecNums[i+1].startNum
                          if(product.quantity >= num && product.quantity < num2){
                            product.displayprice = productSpecNums[i].price
                          }
                        }else{
                          if(product.quantity >= num){
                            product.displayprice = productSpecNums[i].price
                          }
                        }
                      }
                    } else {
                      if (product.productSpec && product.productSpec !== null) {
                        product.displayprice = product.productSpec.specPrice
                      }
                    }
                    productNumber ++
                    if (type === 'reload' && !product.checked) {
                      product.checked = false
                    }

                    product.customFieldCount = 0
                    if (product.customField) {
                      try {
                        product.customField = JSON.parse(product.customField)
                        if (product.customField && Array.isArray(product.customField)) {
                          product.customField.forEach((subItem) => {
                            if (subItem.val && Array.isArray(subItem.val)) {
                              product.customFieldCount += subItem.val.length
                            } else {
                              subItem.val = JSON.parse(subItem.val)
                              if (subItem.val && Array.isArray(subItem.val)) {
                                product.customFieldCount += subItem.val.length
                              }
                            }
                          })
                        }
                      } catch (error) {
                        product.customField = []
                      }
                    }
                  })
                })
              })
              this.productNumber = productNumber
              this.shoppingList = shoppingList
              if (this.shoppingList.length) {
                this.isNoData = false
              } else {
                this.isNoData = true
              }
            }
          }
          localStorage.getItem('paypalQuickPay') === '1' && this.getPaypalAddress()
          this.changeCountry()
        }).finally(() => {
          this.loading = false
        })
      },
      removeProduct (item) {
        let params = {
          id: item.id
        }
        indexApi.getCartRemoveproduct(params).then(res => {
          if (!res.data.code) {
            this.$message.success('remove success')
            this.getBuyerCartList()
          }
        })
      },
      async selectAddress (product, products) {
        this.productId = products.productId
        if ([2, 3].includes(products.logisticsInfo.showType)) {
          this.visible = true
          this.curItem = product
          this.selectItem = products
        }
      },
      checkOut () {
        if (!this.checkedNum) {
          return
        }
        let unit = 'USD'
        let checkedList = []
        let shoppingList =  _.cloneDeep(this.shoppingList)
        shoppingList.forEach((shop) => {
          let checkedListShop = {}
          if (shop.checked) {
            checkedListShop = shop
            let productsList = checkedListShop.items
            productsList.forEach((products,productsIndex) => {
              if (products.deleteTag) {
                productsList.splice(productsIndex, 1)
              }
              let productItems = products.productItems
              productItems.forEach((product,productIndex) => {
                unit = (product.productSpec && product.productSpec.priceUnit) || 'USD'
                product.customField = JSON.stringify(product.customField || [])
                if (!product.checked) {
                  productItems.splice(productIndex, 1)
                } else {
                  if ((product.productSpec && (product.quantity > product.productSpec.invenory)) || product.quantity < product.startNum) {
                    productItems.splice(productIndex, 1)
                  }
                }
              })
            })
          } else {
            let productsList = shop.items
            productsList.forEach((products,productsIndex) => {
              let productItems = products.productItems
              productItems.forEach(product => {
                unit = (product.productSpec && product.productSpec.priceUnit) || 'USD'
                if ((product.productSpec && product.quantity <= product.productSpec.invenory) && (product.quantity >= product.startNum) && !products.deleteTag && product.checked) {
                  if (!checkedListShop.items) {
                    checkedListShop.items = []
                  }
                  if (!checkedListShop.items[productsIndex]) {
                     checkedListShop.items[productsIndex] = {}
                  }
                  if (!checkedListShop.items[productsIndex].productItems) {
                    checkedListShop.items[productsIndex].productItems = []
                  }
                  checkedListShop.items[productsIndex].logisticsInfo = products.logisticsInfo
                  checkedListShop.shopName = shop.shopName
                  checkedListShop.shopId = shop.shopId
                  product.customField = JSON.stringify(product.customField)
                  checkedListShop.items[productsIndex].productItems.push(product)
                  checkedListShop.items[productsIndex].productId = productsList[productsIndex].productId
                }
              })
            })
          }
          if (checkedListShop) {
            checkedListShop.items = checkedListShop.items.filter(item => item)
            checkedList.push(checkedListShop)
          }
        })
        console.log('checkedListShop', checkedList);
        if (checkedList.length && checkedList[0].items && checkedList[0].items.length) {
          let query = {
            unit
          }

          this.payId && (query.payId = this.payId)
          this.$router.push({
            name: 'orderConfirm',
            params: {
              checkedList: checkedList,
            },
            query
          })
        }
      },
      goHome () {
        location.href = location.origin
      },
      toDetail (products) {
        location.href = `${location.origin}/product-detail/${products.product.productName}_pid-${products.productId}.html`
      },
      getImagePath(field) {
        let imagePath = ''
        if (field.type.includes('image/')) {
          if (field.type.includes('gif')) {
            imagePath = field.url
          } else {
            imagePath = `${field.url}?x-oss-process=image/resize,h_36,w_36`
          }
        } else {
          let fileType = field.url.split('.')[field.url.split('.').length - 1]
          imagePath = require('../../assets/img/crmQuotation/' + fileType + '.png')
        }
        return imagePath
      },
    },
    filters: {
      'fixed-num' (value) {
        if (value === 0) {
          return '0.00'
        } else if (value === null || value === undefined || isNaN(value)) {
          return 'Expired'
        } else {
          let lowerValue = value / 100
          return lowerValue.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        }
      }
    }
  }
</script>

<style lang="less">
  @import "~assets/style/variable";
  .shopping-cart {
    margin: 0 auto;
    .shopping-cart-con {
      min-height: calc(~'100vh - 110px');
      padding: 20px;
      background: #ffffff;
      box-sizing: border-box;
      .shopping-cart-header {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        padding: 0 20px;
        margin-bottom: 20px;
        width: 100%;
        height: 40px;
        font-size: 14px;
        text-align: center;
        color: @mainFontColor;
        background: #F5F6F7;
        box-shadow: 0px 1px 0px 0px #E6EAEE;
        box-sizing: border-box;
        .checkbox {
          width: 520px;
          margin-right: 40px;
          text-align: left;
        }
        .header-item {
          width: 440px;
          margin-right: 40px;
        }
        .header-price {
          width: 100px;
          margin-right: 40px;
        }
        .header-quantity {
          width: 130px;
          margin-right: 40px;
        }
        .header-total {
          width: 100px;
          margin-right: 40px;
        }
        .header-operation {
          width: 100px;
          margin-right: 14px;
        }
      }
      .shopping-cart-list {
        .shop-list {
          border: 1px solid #EAECEE;
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          .shop-list-togglecheck {
            height: 40px;
            background: #F7FAFF;
            border-bottom: 1px solid #EAECEE;
            display: flex;
            display: -webkit-flex;
            align-items: center;
            padding-left: 20px;
            .el-checkbox {
              margin-right: 8px;
            }
          }
          .products-list {
            .product-item {
              padding: 20px;
              box-sizing: border-box;
              border-bottom: 1px solid #EAECEE;
              .product-item-togglecheck {
                float: left;
                margin-right: 8px;
                .el-checkbox {
                  .el-checkbox__input {
                    line-height: 80px;
                  }
                }
              }
              .product-item-info {
                display: flex;
                display: -webkit-flex;
                align-items: center;
                // padding-bottom: 19px;
                box-sizing: border-box;
                .product-item-pic {
                  width: 80px;
                  height: 80px;
                  margin-right: 10px;
                }
                .item-product-info {
                  height: 80px;
                  margin-right: 50px;
                  .item-name {
                    width: 400px;
                    max-height: 44px;
                    font-size: 16px;
                    color: #407CFE;
                    line-height: 22px;
                    margin-bottom: 10px;
                    display: -webkit-box!important;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                  }
                  .item-price-type {
                    height: 20px;
                    font-size: 14px;
                    color: #707E8C;
                    line-height: 20px;
                  }
                }
              }
              .item-unit-price {
                width: 100px;
                height: 16px;
                font-size: 14px;
                color: @mainFontColor;
                line-height: 16px;
                margin-right: 40px;
              }
              .item-number {
                position: relative;
                margin-right: 60px;
                .delete-tips {
                  font-size: 12px;
                  color: #516273;
                  margin-top: 10px;
                }
                .error-tips {
                  position: absolute;
                  top: 42px;
                  width: 300px;
                  font-size: 12px;
                  color: #F25F55;
                }
              }
              .item-total-price {
                width: 100px;
                height: 16px;
                font-size: 14px;
                color: @mainFontColor;
                line-height: 16px;
                margin-right: 40px;
              }
              &.error-product-item {
                background: rgba(242,95,85,0.05);
              }
              &.delete-product-item {
                background: #F5F6F7;
              }
            }
            .item-btn-group {
              .remore-btn {
                height: 16px;
                font-size: 14px;
                color: @mainFontColor;
                line-height: 16px;
                cursor: pointer;
              }
            }
            &:last-child {
              .product-item {
                &:last-child {
                  border-bottom: none;
                }
              }
            }
          }
        }
      }
      .shopping-cart-footer {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        box-sizing: border-box;
        padding-left: 20px;
        margin: 20px auto 0;
        background: #F5F6F7;
        .footer-right {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          .items-info {
            margin-right: 20px;
            .words-top {
              margin-bottom: 4px;
              .items-number {
                height: 20px;
                font-size: 14px;
                font-weight: 400;
                color: @mainFontColor;
                line-height: 20px;
                margin-right: 6px;
              }
              .items-price {
                height: 24px;
                font-size: 20px;
                font-weight: 500;
                color: #F25F55;
                line-height: 24px;
              }
            }
            .words-bottom {
              height: 20px;
              font-size: 14px;
              color: #707E8C;
              line-height: 20px;
              text-align: center;
            }
          }
          .checkout-btn {
            padding: 18px 30px;
            font-size: 20px;
            color: #ffffff;
            background: #407CFE;
            line-height: 24px;
            cursor: pointer;
            &.disabled-btn {
              background-color: rgb(160, 190, 255);
            }
          }
        }
      }
    }
    .empty-data {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      .empty-data-img {
        width: 144px;
        margin-bottom: 20px;
      }
      .empty-tips {
        font-size: 16px;
        color: @mainFontColor;
        line-height: 22px;
        margin-bottom: 20px;
      }
      .sign-in-tips {
        height: 20px;
        font-size: 14px;
        color: #707E8C;
        line-height: 20px;
        .sign-in-btn {
          color: #407CFE;
          cursor: pointer;
        }
      }
      .contimue-btn {
        font-size: 14px;
        color: #407CFE;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .shipping-1 {
      margin: 10px 0 0 112px;
      &-loc {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 20px;
      }
      .shipping-time {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #222222;
        line-height: 20px;
      }
    }
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1000;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 4px;
    }
    .additionalInfo-reference {
      margin: 10px 0 0 112px;
      font-size: 12px;
      color: #2d55fa;
      line-height: 16px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .additionalInfo-popover {
    padding: 12px;
    .additionalInfo-con {
      .title {
        font-size: 14px;
        color: #272829;
        line-height: 20px;
      }
      .additionalInfo-list {
        box-sizing: border-box;
        max-height: 220px;
        overflow-y: auto;
        margin-top: 8px;
        .additionalInfo {
          .field-item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            padding: 2px 10px;
            background-color: #f2f3f5;
            border-radius: 3px;
            gap: 10px;
            margin-bottom: 5px;
            .info-base {
              flex: 1 1 auto;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              min-width: 0;
              gap: 10px;
              .img {
                flex: 0 0 auto;
                width: 36px;
                height: 36px;
                object-fit: contain;
              }
              .name {
                flex: 1 1 auto;
                width: 0;
                font-size: 14px;
                color: #272829;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .icondownload {
              font-size: 14px;
              height: 14px;
              line-height: 14px;
              display: inline-block;
              vertical-align: baseline;
              color: #3d3e40;
              cursor: pointer;
              &:hover {
                color: #2D55FA;
              }
            }
          }
        }
      }
    }
  }
</style>
